import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCertList, setCertCodeSubscribedList, setCertCodeInFocus } from "../../redux/slices/practiceSlice";
import { setIsExamInProgress, setLatestExamType } from "../../redux/slices/examSlice";
import { login, primaryRole } from "../../redux/slices/userSlice";
import standardBizApiClient from "../../util/BizApi/standardBizApiClient";
import { handleSignout } from "../../util/functions/handleSignout";

const SupportLogin = () => {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const signedIn = useSelector((state) => state.user.signedIn);

    useEffect(() => {
        handleSupportLogin();
    }, [])

    const handleSupportLogin = async () => {
        if (signedIn) {
            await handleSignout();
        }

        const query = new URLSearchParams(search, [search]);
        const userId = query.get("user_id");
        const token = query.get("token");
        const session = query.get("session");
        if (!userId || !token || !session) return;

        const supportLoginRes = await standardBizApiClient.account_support_login(userId, token, session);
        if (supportLoginRes?.is_error) {
            return;
        }
    
        const { certs, primary_role, exam_meta, user_id, email_address} = supportLoginRes;
        const { cert_code_in_focus, cert_code_subscribed_list, cert_list } = certs;
        const { exam_type } = exam_meta;
        const newIsExamInProgress = Boolean(exam_type);

        dispatch(setCertCodeInFocus(cert_code_in_focus));
        dispatch(setCertCodeSubscribedList(cert_code_subscribed_list));
        dispatch(setCertList(cert_list));

        dispatch(setLatestExamType(exam_type));
        dispatch(setIsExamInProgress(newIsExamInProgress));

        // Pass the user data to the login action - use user_id from response or fallback to URL param
        const finalUserId = user_id || userId;
        dispatch(login({ 
            userId: finalUserId,
            email: email_address
        }));
        dispatch(primaryRole(primary_role));
        window.location.href = "/";
    }

    return (
        <div>

        </div>
    )
}

export default SupportLogin;